<template>
  <router-view />
</template>
<script>
import { defineComponent, onMounted } from 'vue'
import { useStore } from '@/store'

export default defineComponent({
  setup() {
    const store = useStore()
    onMounted(() => {
      store.dispatch('global/loadOptionFilterList')
    })
  }
})
</script>
